import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a483136"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "slogan-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "container-blue" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Geen poster kan zonder "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" een goede slogan. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Welke kies jij? ")
  ])
], -1))
const _hoisted_3 = { id: "slogan-container" }
const _hoisted_4 = {
  key: 0,
  id: "slogans"
}
const _hoisted_5 = { id: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_header = _resolveComponent("top-header")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_submit_button = _resolveComponent("submit-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_top_header),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!!_ctx.slogans)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slogans, (slogan, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `slogan-logo-${i}`,
                class: "slogan-row"
              }, [
                _createVNode(_component_checkbox, {
                  class: "vote-icon",
                  modelValue: _ctx.active === i,
                  "onUpdate:modelValue": ($event: any) => (_ctx.setSlogan(i))
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createElementVNode("p", null, _toDisplayString(slogan.label), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_submit_button, {
        id: "submit-button",
        href: "/poster-bekijken",
        disabled: !_ctx.hasSlogan
      }, {
        default: _withCtx(() => [
          _createTextVNode("OK")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}